import React from "react";
import "./AboutFounderMessage.css";
import founderPhoto from "../../Assets/image 19.png";
import waveBg from "../../Assets/background-wave.png";
import dotPattern from "../../Assets/about/rect.png";
import vcnrLogo from "../../Assets/vcnr-logo-white.png";

const FounderMessage = () => {
  return (
    <section className="founder-section">
      <img src={waveBg} alt="Background Waves" className="bg-wave" />
      <div className="founder-container">
        <div className="founder-left">
          <div className="founder-image-wrapper">
            <img src={dotPattern} alt="Dot pattern" className="dot-pattern" />
            <img src={founderPhoto} alt="Founder" className="founder-image" />
          </div>
        </div>
        <div className="founder-right">
          <h2 className="founder-heading">Our Founder’s <br />Message</h2>
          <img src={vcnrLogo} alt="VCNR Logo" className="vcnr-logo" />
          <h4 className="founder-name">
            MR. NARASIMHAMURTHY <br /> Founder & Chairman, VCNR Group
          </h4>
          <p className="founder-text">
            VCNR was born from a simple but powerful belief: progress must be inclusive. Growth, to me, has always meant more than numbers, it must carry purpose, create opportunity, and uplift lives. I didn’t set out to construct buildings. I set out to build a better tomorrow.
          </p>
          <p className="founder-text">
           From humble beginnings to leading a group with national presence, this journey has never been just about business. It’s about people, perseverance, and doing what’s right, even when it’s not easy.
          </p>
          <p className="founder-text">
            As we move forward, I hope VCNR continues to stand for something greater than enterprise. A platform for impact. A home for integrity. And a legacy of value for generations to come.
            </p>
          <button className="explore-btn">Read Full Biography</button>
        </div>
      </div>
    </section>
  );
};

export default FounderMessage;
